import { marked } from 'marked';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

export const Markdown = () => {
    const params = useParams();
    const [html, setHtml] = useState('');

    useEffect(() => {
        fetch(`/${params.filename}.md`)
            .then(response => response.text()).catch(() => 'File not found')
            .then((text: any) => {
                setHtml(marked(text) as string)
            }
            );
    }, [params]);


    return (
        <>
            <div className="markdown fixed top-0 p-10" dangerouslySetInnerHTML={{ __html: html }} />
        </>
    );
}